var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPencilEditIcon = function SvgPencilEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 0.1,
    y: 0.654,
    fill: "#EFEBEE",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5B3552",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m25.59 12.148 2.734 2.732m-.976-5.139-7.39 7.39a2.73 2.73 0 0 0-.748 1.396l-.682 3.417 3.416-.684a2.73 2.73 0 0 0 1.396-.747l7.39-7.39a2.393 2.393 0 0 0 0-3.382 2.39 2.39 0 0 0-3.382 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5B3552",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M28.85 24.524v3.871a2.58 2.58 0 0 1-2.58 2.58H12.076a2.58 2.58 0 0 1-2.58-2.58V14.202a2.58 2.58 0 0 1 2.58-2.58h3.871"
  })));
};
export { SvgPencilEditIcon as ReactComponent };
export default __webpack_public_path__ + "images/pencil-edit-icon.svg";